import { render, staticRenderFns } from "./ResearcherInterest.vue?vue&type=template&id=13d1bca2"
import script from "./ResearcherInterest.vue?vue&type=script&lang=js"
export * from "./ResearcherInterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports